import { translate, translateFormatter, type RichTextFormatter } from '@/domains/core/localization/translate';
export const {
  soldBy,
  otherOffers,
  offersViewed,
  offersFromOthers,
  offersViewMore,
  offerSelledBy
} = translate({
  "soldBy": "Sold by ",
  "otherOffers": "See other offers",
  "offersViewed": "Product being viewed",
  "offersFromOthers": "Offers from other sellers",
  "offersViewMore": "View More",
  "offerSelledBy": "Sold by"
});
export const availableBy = translateFormatter<{
  total: number;
}>([{
  "type": 0,
  "value": "Product available from "
}, {
  "type": 1,
  "value": "total"
}, {
  "type": 0,
  "value": " other seller(s)"
}], undefined, undefined, "en");
export const otherVendors = translateFormatter<{
  total: number;
  text: RichTextFormatter;
}>([{
  "type": 0,
  "value": " and "
}, {
  "type": 8,
  "value": "text",
  "children": [{
    "type": 6,
    "value": "total",
    "options": {
      "=1": {
        "value": [{
          "type": 0,
          "value": "1 other seller"
        }]
      },
      "other": {
        "value": [{
          "type": 7
        }, {
          "type": 0,
          "value": " other sellers"
        }]
      }
    },
    "offset": 0,
    "pluralType": "cardinal"
  }]
}], undefined, undefined, "en");
export const discoverTheStore = translateFormatter<{
  brandName: string;
}>([{
  "type": 0,
  "value": "Discover the "
}, {
  "type": 1,
  "value": "brandName"
}, {
  "type": 0,
  "value": " store"
}], undefined, undefined, "en");